"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserSpecificNotificationEntrySchema = exports.isUserSpecificNotificationType = exports.UserSpecificNotificationTypeSchema = void 0;
const z = __importStar(require("zod"));
const iso_date_string_types_1 = require("./iso_date_string_types");
exports.UserSpecificNotificationTypeSchema = z.union([
    z.literal("7daysintotrial"),
    z.literal("30daysintosubscription"),
    z.literal("90daysintosubscription"),
]);
const isUserSpecificNotificationType = (x) => exports.UserSpecificNotificationTypeSchema.safeParse(x).success;
exports.isUserSpecificNotificationType = isUserSpecificNotificationType;
exports.UserSpecificNotificationEntrySchema = z.object({
    endDate: iso_date_string_types_1.IsoDateStringSchema,
    startDate: iso_date_string_types_1.IsoDateStringSchema,
    type: exports.UserSpecificNotificationTypeSchema,
});
//# sourceMappingURL=user_specific_notification_types.js.map